<ng-container *screenSizes="let size">

  <mat-icon class="text-primary" [svgIcon]="svgIcon" *ngIf="svgIcon"></mat-icon>

  <button
    *ngIf="size.isXS && containerContent.scrollWidth > containerContent.clientWidth"
    class="arrow-btn"
    [disabled]="!showButtons.left"
    (click)="scroll('left')"
  >
    <mat-icon class="text-primary cursor-pointer" svgIcon="mat_solid:chevron_left"></mat-icon>
  </button>

  <div #containerContent class="flex-auto overflow-hidden">
    <div class="flex gap-4">
      <ng-content />
    </div>
  </div>

  <button
    *ngIf="size.isXS && containerContent.scrollWidth > containerContent.clientWidth"
    class="arrow-btn"
    [disabled]="!showButtons.right"
    (click)="scroll('right')"
  >
    <mat-icon class="text-primary cursor-pointer" svgIcon="mat_solid:chevron_right"></mat-icon>
  </button>

</ng-container>